/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery().ready( function($) {
  var data = $('.size.OptionSelector .Popover__Value').data('value');
  var size = $('.ProductForm__Option.size .ProductForm__SelectedValue').text();
  var str = $('.ProductForm__Option.material .ProductForm__SelectedValue').text();
  console.log(size);
  if(size == "A3" || size == "A2" || size == "A1" || data == "A3" || data == "A2" || data == "A1") {
    $('button.Popover__Value[data-value="N/A"]').trigger("click");
    $('button.material.ProductForm__Item button.Popover__Value').show();
    $('button[data-value="Aluminum"], button[data-value="Acrylic"], button[data-value="Aluminum"], button[data-value="Framed (Classic Semi-Glossy Framed 170GSM)"], button[data-value="Framed (Premium Semi-Glossy Framed 200GSM)"], button[data-value="Framed (Archival Matte 250GSM)"]').addClass('closed');
    $('button[data-value="Aluminum"], button[data-value="Acrylic"], button[data-value="Aluminum"], button[data-value="Framed (Classic Semi-Glossy Framed 170GSM)"], button[data-value="Framed (Premium Semi-Glossy Framed 200GSM)"], button[data-value="Framed (Archival Matte 250GSM)"]').hide();
  }

  if(size == 'A4' || data == "A4") {
    $('button.Popover__Value').show();
    $('button[data-value="Aluminum"], button[data-value="Acrylic"]').hide();
  }

  if(size == '30x45' || size == '45x60' || size == '60x90' || data == '30x45' || data == '45x60' || data == '60x90') {
    $('button.material.ProductForm__Item button.Popover__Value').show();
  }

  if(size == '30x90' || data == '30x90') {
    $('.material.OptionSelector button.Popover__Value').hide();
    $('button[data-value="Aluminum"], button[data-value="Acrylic"]').show();
    $('button.Popover__Value[data-value="N/A"]').trigger("click");
  }
  
  if(str.includes('Framed') || str.includes('framed')) {
    $('button.Popover__Value[data-value="White Wood"]').trigger("click");
    $('.ProductForm__Option.style span.ProductForm__SelectedValue').text('White Wood');
    $('.ProductForm__Option.style').show();
  }
  else {
    $('.ProductForm__Option.style').hide();
  }

  $(".material.OptionSelector .Popover__Value").click(function(){ 
    var strr = $(this).data('value');
    var str = $('.ProductForm__Option.material .ProductForm__SelectedValue').text();
    console.log(str);
    if(strr.includes('Framed') || strr.includes('framed')) {
      $('.ProductForm__Option.style span.ProductForm__SelectedValue').text('White Wood');
      $('button.Popover__Value[data-value="White Wood"]').trigger("click");
      $('.ProductForm__Option.style').show();
    }
    else {
      $('.ProductForm__Option.style').hide();
      $('button.Popover__Value[data-value="N/A"]').trigger("click");
    }
  });

  $(".size.OptionSelector .Popover__Value").click(function(){
    var data = $(this).data('value');
    $('.material.OptionSelector button.Popover__Value').show();
    
    if(data == "A3" || data == "A2" || data == "A1") {
      $('.ProductForm__Option.style').hide();
      $('button.Popover__Value[data-value="N/A"]').trigger("click");
      $('button.Popover__Value[data-value="Paper (Premium Semi Glossy 200GSM)"]').trigger("click");
      $('.ProductForm__Option:nth-child(2) .ProductForm__SelectedValue').text('Paper (Premium Semi Glossy 200GSM)');
      $('button.material.ProductForm__Item button.Popover__Value').show();
      $('button[data-value="Aluminum"], button[data-value="Acrylic"], button[data-value="Aluminum"], button[data-value="Framed (Classic Semi-Glossy Framed 170GSM)"], button[data-value="Framed (Premium Semi-Glossy Framed 200GSM)"], button[data-value="Framed (Archival Matte 250GSM)"]').addClass('closed');
      $('button[data-value="Aluminum"], button[data-value="Acrylic"], button[data-value="Aluminum"], button[data-value="Framed (Classic Semi-Glossy Framed 170GSM)"], button[data-value="Framed (Premium Semi-Glossy Framed 200GSM)"], button[data-value="Framed (Archival Matte 250GSM)"]').hide();
    }

    if(data == 'A4') {
      $('.ProductForm__Option:nth-child(2) .ProductForm__SelectedValue').text('Paper (Premium Semi Glossy 200GSM)');
      $('button.Popover__Value').show();
      $('button.Popover__Value[data-value="Paper (Premium Semi Glossy 200GSM)"]').trigger("click");
      $('button[data-value="Aluminum"], button[data-value="Acrylic"]').addClass('closed');
      $('button[data-value="Aluminum"], button[data-value="Acrylic"]').hide();
    }

    if(data == '30x45' || data == '45x60' || data == '60x90') {
      $('button.Popover__Value[data-value="Paper (Premium Semi Glossy 200GSM)"]').trigger("click");
      $('.ProductForm__Option:nth-child(2) .ProductForm__SelectedValue').text('Paper (Premium Semi Glossy 200GSM)');
      $('button.material.ProductForm__Item button.Popover__Value').show();
    }

    if(data == '30x90') {
      $('.ProductForm__Option.style').hide();
      $('button.Popover__Value[data-value="Aluminum"]').trigger("click");
      $('button.Popover__Value[data-value="N/A"]').trigger("click");
      $('.ProductForm__Option:nth-child(2) .ProductForm__SelectedValue').text('Aluminum');
      $('.material.OptionSelector button.Popover__Value').addClass('closed');
      $('.material.OptionSelector button.Popover__Value').hide();
      $('button[data-value="Aluminum"], button[data-value="Acrylic"]').removeClass('closed');
      $('button[data-value="Aluminum"], button[data-value="Acrylic"]').show();
    }
  });
});

